module.exports = __webpack_public_path__ + "img/project_quality.b79dacc7.svg";